import { POST } from '@/api'
import { keyBy } from 'lodash'

/**
 * 画像メモ取得・登録
 */
export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
  },
  mutations: {
    set(state, memos) {
      state.byId = keyBy(memos, 'id')
      state.allIds = memos.map(memo => memo.id)
    },
    delete(state, id) {
      delete state.byId[id]
      state.allIds = state.allIds.filter(item => item !== id)
    },
    clear(state) {
      state.byId = {}
      state.allIds = []
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    all: ({ byId, allIds }) => allIds.map(id => byId[id]),
  },
  actions: {
    async get(store, customerId) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/image_memo/list', { customer_id: customerId })
      if (status === 200) {
        const { imageMemo, freehandMemo } = data
        const memos = [
          ...imageMemo.map(memo => ({ ...memo, isFreeHand: false })),
          ...freehandMemo.map(memo => ({ ...memo, isFreeHand: true })),
        ]
        commit('set', memos)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
    async regist(store, { customerId, blob }) {
      const { commit } = store
      commit('busy', true)

      const formData = new FormData()
      formData.append('customer_id', customerId)
      formData.append('image_memo', blob, 'customer.jpeg')
      const { status, message } = await POST('/api/web/image_memo/regist', formData)
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
